import { clsx } from 'clsx';
import { type FC, type JSX } from 'react';

import styles from './Card.css';

type CardProps = {
  title: string;
  description: JSX.Element | string;
  image?: JSX.Element;
  theme?: 'default' | 'orange';
};

export const Card: FC<CardProps> = ({ title, description, theme, image }) => (
  <div className={clsx(styles['container'], theme === 'orange' && styles['container--orange'])} data-testid="card">
    <span className={styles['title']}>{title}</span>
    {image}
    <span className={styles['description']}>{description}</span>
  </div>
);
